module.exports = __webpack_public_path__ + "img/产品规划及优势.13191e80.png";